import { tr, usePartnerTranslation } from "../../../lib/language";
import React from "react";
import { SectionHeader } from "./fields";

const StepAcknowledgment = () => {
  usePartnerTranslation();
  return <section data-testid="step-acknowledge" className="space-y-4">
    <SectionHeader title={tr("Before we begin")} />
    <p className="text-sm leading-relaxed text-[#0F1115]">{tr("You'll need about ")}<strong className="font-semibold">{tr("10–15 minutes")}</strong>:{" "}{tr("basic descriptions, 4–10 photos, and at least one bookable option with a price and schedule.")}</p>
    <p className="text-sm leading-relaxed text-[#6B7280]">{tr("By continuing, you acknowledge that you are authorized to use the content you upload for this product and that this product/activity complies with the laws and regulations of the place where it is offered.")}</p>
  </section>;
};

export default StepAcknowledgment;
